import { useCallback, useEffect, useState } from 'react';
import { sanitizeAndValidatePhone } from 'features/message-center/utils';
import { searchByPhoneNumber } from 'services/Names';
import { PHONE_TYPE_MAP } from 'UI/components/organisms/PhoneNumbersForm/utils';

export const useSearchContacts = ({ initialPhoneNumber }) => {
  const [contact, setContact] = useState(null);
  const [uiState, setUiState] = useState({ isSearching: false, hasFinished: false });

  const handleSelectValue = useCallback(async value => {
    if (!value) {
      setContact(null);
      return;
    }
    if (value?.createButton) {
      const validPhone = sanitizeAndValidatePhone(value.keyword);

      const newContact = {
        ...value,
        fullName: '',
        full_name: value.keyword,
        industryAndRole: '',
        email: '',
        phone: validPhone,
        type_id: PHONE_TYPE_MAP[2].id
      };

      setContact(newContact);
      return;
    }

    setContact({
      ...value,
      fullName: value.full_name,
      phone: value.phone,
      industryAndRole: `${value.industry} / ${value.role}`,
      email: value.email
    });
  }, []);

  useEffect(() => {
    if (!initialPhoneNumber) return;

    const search = async phoneNumber => {
      setUiState(prevState => ({ ...prevState, isSearching: true }));

      const result = await searchByPhoneNumber(phoneNumber);
      const data = result?.data?.data;
      const foundContact = data?.length > 0 && data[0];

      const contactToShow = foundContact || { keyword: initialPhoneNumber, createButton: true };
      handleSelectValue(contactToShow);

      setUiState(prevState => ({ ...prevState, isSearching: false, hasFinished: true }));
    };

    search(initialPhoneNumber);
  }, [initialPhoneNumber, handleSelectValue]);

  return {
    contact,
    handleSelectValue,
    uiState
  };
};
